import * as types from "../constants/actionTypes";
import { logAndylitics, log, logAPI } from "./andyliticsApi";
import * as AuthorizationsApi from './healthPlanServices/authorizationsApi';
import * as BenefitsApi from './healthPlanServices/benefitsApi';
import * as ClaimsApi from './healthPlanServices/claimsApi';
import * as DocumentsApi from './healthPlanServices/documentsApi';
import * as InvoiceApi from './healthPlanServices/invoiceApi';
import * as MemberApi from './healthPlanServices/memberApi';
import * as SupportApi from './healthPlanServices/supportApi';
import * as SsoApi from './healthPlanServices/ssoApi';
import * as OtherCoverageApi from './healthPlanServices/otherCoverageApi';
import * as ProcessControlEventsApi from './healthPlanServices/processControlEventsApi';
import * as NotificationPreferencesApi from './healthPlanServices/NotificationPreferencesApi';
import * as EstimatorApi from './healthPlanServices/estimatorApi';
import * as TaxFormsApi from './healthPlanServices/taxFormsApi';
import * as tools from "../helpers/Tools";
const webTpaApiUrl = typeof window !== 'undefined' ? window.serverData.data.webTPAUrl : ''; // window is undefined during pre-render
const hpServicesUrl = typeof window !== 'undefined' ? (window.serverData.data.hpServicesSpecificUrl ? window.serverData.data.hpServicesSpecificUrl : window.serverData.data.hpServicesUrl) : ''; // window is undefined during pre-render

export {
    AuthorizationsApi,
    BenefitsApi,
    ClaimsApi,
    DocumentsApi,
    InvoiceApi,
    MemberApi,
    SupportApi,
    SsoApi,
    TaxFormsApi,
    OtherCoverageApi,
    NotificationPreferencesApi,
    EstimatorApi,
    ProcessControlEventsApi
}

export const getFCHPUserData = (token, sPrefix) => {
    let hpParams = {
        method: "POST",
        headers: {
            "Authorization": 'bearer ' + token,
            "Content-type": "application/json"
        },
        body: JSON.stringify({
            "loginOrganization": "FCHP"
        })
    };

    //var url = "http://localhost:60512/api/SecurityTokens/v1/Authenticate"
    //var url = hpServicesUrl + "/oauth/token"; // "https://apis-sand-scentral.bswhive.com/ApiGatewayApi/api/SecurityTokens/v1/Authenticate";
    var url = tools.buildUrl(tools.hpAPIBaseURL(), '/oauth/token')
    if (sPrefix === "HR") {
        return webtpaFetch(url, hpParams).then(res => { //make hp call to our apis
            //debugger;
            if (res.status !== 200) return null;
            return res.json().then(identity => { //if call succeeded, get the token
                //window.store.dispatch({ type: types.HP_USERDATA_STORETOKEN, token: token });
                //url = hpServicesUrl + "/SecurityTokens/ValidateJwt?token=" + token;
                //return webtpaFetch(url).then(identityResponse => {
                //    return identityResponse.json().then(identityObject => {
                //        return identityObject;
                //    });
                //});
                return identity;
            });
        });
    }
};

export const getUserPayerData = (token, hpPayerId) => {
    var url = tools.buildUrl(tools.hpAPIBaseURL(), '/member/ismemberpayer');

    let hpParams = {
        method: "POST",
        headers: {
            "Authorization": 'bearer ' + token,
            "Content-type": "application/json"
        },
        body: JSON.stringify({
            MemberId: hpPayerId
        })
    };

    return fetch(url, hpParams).then(response => {
        if (response && response.status && response.status >= 200 && response.status < 300) {
            return Promise.resolve(response.json());
        } else {
            return Promise.reject(response);
        }
    });
};

export const webtpaFetch = (url, params) => {
    if (typeof params === "undefined" || params === null) {
        params = { method: "GET" }
    }
    params.headers = params.headers || {};
    params.headers["Accept"] = "application/json";
    params.headers["Content-type"] = "application/json";
    params.headers["Cache-Control"] = "no-cache";
    params.headers["Pragma"] = "no-cache";

    return fetchWithCreds(url, params);
}